"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetQuestConfigsSortToJSON = exports.GetQuestConfigsSortFromJSONTyped = exports.GetQuestConfigsSortFromJSON = exports.GetQuestConfigsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetQuestConfigsSort;
(function (GetQuestConfigsSort) {
    GetQuestConfigsSort["CreatedAt"] = "createdAt";
})(GetQuestConfigsSort = exports.GetQuestConfigsSort || (exports.GetQuestConfigsSort = {}));
function GetQuestConfigsSortFromJSON(json) {
    return GetQuestConfigsSortFromJSONTyped(json, false);
}
exports.GetQuestConfigsSortFromJSON = GetQuestConfigsSortFromJSON;
function GetQuestConfigsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetQuestConfigsSortFromJSONTyped = GetQuestConfigsSortFromJSONTyped;
function GetQuestConfigsSortToJSON(value) {
    return value;
}
exports.GetQuestConfigsSortToJSON = GetQuestConfigsSortToJSON;
